import config from '../config';

function checkSupportLanguage(language) {
  return config.languages.list.has(language);
}

function detectByBrowser() {
  const language = navigator.language.split('-')[0];
  if (language && checkSupportLanguage(language)) {
    return language;
  }

  return null;
}

export function detectByUrl() {
  const language = document.location.href.split('/')[3];
  if (language && checkSupportLanguage(language)) {
    return language;
  }

  return null;
}

function saveSelectedLanguage(language) {
  localStorage.setItem('language', language);
}

function getSelectedLanguage() {
  return localStorage.getItem('language');
}

function getUserLanguage() {
  let language = detectByUrl();

  if (language !== null) {
    saveSelectedLanguage(language);
  }

  if (language === null) {
    language = getSelectedLanguage();
  }

  if (language === null) {
    language = detectByBrowser();
  }

  if (language === null) {
    return config.languages.default;
  }

  return language;
}

const userLanguage = getUserLanguage();

export function detectUserLanguage() {
  return userLanguage;
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js